import React, {useEffect, useState} from 'react';
import {useLocation, useParams} from "react-router-dom";
import IssuanceEstimateUnitTable from "../../../../components/UI/table/prodaction/estimate/IssuanceEstimateUnitTable";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import {Box} from "@mui/system";
import {constantsErrorMessages} from "../../../../Constants";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import MaterialEstimateUnitService from "../../../../API/orders/estimate/organization/MaterialEstimateUnitService";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import {Paper} from "@mui/material";
import ButtonSelectAction from "../../../../components/UI/button/ButtonSelectAction";
import {ModalSelectAction} from "../../../../components/UI/modal/ModalSelectAction";
import ModalConfirm from "../../../../components/UI/modal/ModalConfirm";
import UnitService from "../../../../API/orders/warehouse/UnitService";

const IssuancePieceMaterialsItem = () => {
    const [data, setData] = useState([]);
    const [alertData, setAlertData] = useState({});
    const [rowSelection, setRowSelection] = useState([]);
    const [open, setOpen] = useState(false)
    const [openModalConfirmType, setModalConfirmType] = useState("")
    const [unitMap, setUnitMap] = useState({});
    const params = useParams();
    let orderId = params.id;
    let orderNumber = params.order;
    const pathname = useLocation().pathname
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }


    useEffect(() => {
        getStartPageSize()
        UnitService.getAll()
            .then(function (response) {
                let data = response.data;
                const unitMapData = data.reduce((acc, el) => ({...acc, [el.id]: el.name}), {})
                setUnitMap(unitMapData)
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => {
                MaterialEstimateUnitService.getAllPieceMaterialsByOrderId(orderId).then(function (response) {
                    const data = response.data;
                    setData(data);
                    setTableOptions((prev) => ({...prev, totalElements: data.length}))
                })
                    .catch(function (error) {
                        handleModalAlert(error);
                    });
            })
    }, []);

    const modalActions = [
        {name: "Упаковать", type: "pack"},
        {name: "Отменить упаковку", type: "packСancel"},
        {name: "Выдать", type: "issue"},
    ]

    const handleSelectAction = (action) => {
        setModalConfirmType(action)
        setOpen(false)
    }

    const reloadPieceMaterials = () => MaterialEstimateUnitService.getAllPieceMaterialsByOrderId(orderId)
        .then(function (response) {
            const nextData = response.data;
            setData(nextData);
            setTableOptions((prev) => ({...prev, totalElements: nextData.length}));
        });

    const handleSubmit = async () => {
        if (openModalConfirmType === "pack" || openModalConfirmType === "packСancel") {
            MaterialEstimateUnitService.packaging(rowSelection, openModalConfirmType === "pack", orderId)
                .then(function () {
                    return reloadPieceMaterials();
                })
                .then(function () {
                    setModalConfirmType("");
                    setRowSelection([])
                    handleModalAlert("Подтверждено", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        } else {
            MaterialEstimateUnitService.issues(rowSelection, orderId)
                .then(function () {
                    return reloadPieceMaterials();
                })
                .then(function () {
                    setModalConfirmType("");
                    setRowSelection([])
                    handleModalAlert("Подтверждено", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        }
    }
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Выдача штучных материалов заказа: ${params.order}`}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Выдача штучных материалов", href: "/organization/issuance-piece-materials"},
                ]}/>
            <Typography component="p" sx={{paddingBottom: "10px", fontSize: "24px", fontWeight: 700}}>
                Выдача штучных материалов заказа: {params.order}
            </Typography>
            <IssuanceEstimateUnitTable
                data={data}
                setData={setData}
                orderId={orderId}
                orderNumber={orderNumber}
                tableOptions={tableOptions}
                rowSelection={rowSelection}
                setRowSelection={setRowSelection}
                tableOptionsHandle={tableOptionsHandle}
                unitMap={unitMap}
                handleModalAlert={handleModalAlert}
            />
            {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: '100%',
                height: "88px",
                display: 'flex',
                justifyContent: "center",
                alignItems: 'center',
                backgroundColor: (theme) => theme.palette.primary.lightGrey,
            }} component="footer">
                <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
            </Paper>}
            <ModalSelectAction
                open={open}
                reset={() => setOpen(false)}
                submit={handleSelectAction}
                modalActions={modalActions}
            />
            <ModalConfirm
                title={openModalConfirmType === "pack" ? "Подтвердить упаковку материалов?" : openModalConfirmType === "packСancel" ? "Подтвердить отмену упаковки?" : "Подтвердить выдачу материалов?"}
                modalOpen={openModalConfirmType}
                handleClose={() => setModalConfirmType("")}
                handleSubmit={handleSubmit}
                action={"Подтвердить"}
            />
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export default IssuancePieceMaterialsItem;